import React from 'react';

const renderInline = (text, keyPrefix) => {
  const parts = text.split('**');
  return parts.map((part, index) => {
    if (index % 2 === 1) {
      return <strong key={`${keyPrefix}-b-${index}`}>{part}</strong>;
    }
    return <React.Fragment key={`${keyPrefix}-t-${index}`}>{part}</React.Fragment>;
  });
};

const StatusText = ({ text, className = '' }) => {
  if (!text) return null;

  const lines = text.split('\n');
  const elements = [];
  let listItems = [];
  let blockIndex = 0;

  const flushList = () => {
    if (listItems.length > 0) {
      elements.push(
        <ul key={`list-${blockIndex++}`} className="list-disc pl-5 mb-2 space-y-1">
          {listItems}
        </ul>
      );
      listItems = [];
    }
  };

  lines.forEach((line, index) => {
    const bulletMatch = line.match(/^\s*[-*]\s+(.*)$/);
    if (bulletMatch) {
      listItems.push(
        <li key={`li-${index}`}>
          {renderInline(bulletMatch[1], `li-${index}`)}
        </li>
      );
      return;
    }

    flushList();

    if (line.trim() === '') {
      elements.push(<div key={`spacer-${index}`} className="h-2" />);
      return;
    }

    elements.push(
      <p key={`p-${index}`} className="mb-2">
        {renderInline(line, `p-${index}`)}
      </p>
    );
  });

  flushList();

  return <div className={className}>{elements}</div>;
};

export default StatusText;
